export default __webpack_public_path__ + "static/media/quantisal_step8.ba65fa83.png";